const TAB_NAMES = {
  JUDGING: { label: 'Judging', value: 'judging' },
  ORDER: { label: 'Order of Go', value: 'order-of-go' },
  SCORING: { label: 'Scoring', value: 'scoring' },
  PRIZE_MONEY: { label: 'Results', value: 'prize-money' },
}

const TABS = [
  { tab: TAB_NAMES.JUDGING.label, id: TAB_NAMES.JUDGING.value },
  { tab: TAB_NAMES.ORDER.label, id: TAB_NAMES.ORDER.value },
  { tab: TAB_NAMES.SCORING.label, id: TAB_NAMES.SCORING.value, disabled: true },
  { tab: TAB_NAMES.PRIZE_MONEY.label, id: TAB_NAMES.PRIZE_MONEY.value, disabled: true },
]

const PUBLISH_KEYS = {
  [TAB_NAMES.JUDGING.value]: 'publishJudging',
  [TAB_NAMES.ORDER.value]: 'publishOrder',
  [TAB_NAMES.SCORING.value]: 'publishScore',
  [TAB_NAMES.PRIZE_MONEY.value]: 'publishPrize',
}

export enum DateEnum {
  'h',
  'm',
  's',
  'f',
}

const RIDER_COLUMNS_WIDTH: { [key: string]: string } = {
  rider: '25%',
  horse: '25%',
  class: '25%',
  order: '11%',
  rideTime: '10%',
  drag: '4%',
}

const CLASS_COLUMNS_WIDTH: { [key: string]: string } = {
  rider: '29%',
  horse: '29%',
  order: '12%',
  rideTime: '21%',
  drag: '9%',
}

export const MANAGE_OPERATIONS_CONSTS = {
  TABS,
  TAB_NAMES,
  PUBLISH_KEYS,
  CLASS_COLUMNS_WIDTH,
  RIDER_COLUMNS_WIDTH,
}
